import React from 'react';

import { I18n } from 'common/i18n';
import { Modal, ModalHeader, ModalContent, ModalFooter } from 'common/components/Modal';
import AssetBrowser from 'common/components/AssetBrowser';
import { ASSET_SELECTOR, RENDER_STYLE_CARD } from 'common/components/AssetBrowser/lib/constants';

import './index.scss';

export interface AssetSelectorProps {
  additionalTopbarComponents?: any[];
  assetSelector?: boolean;
  baseFilters?: object;
  closeOnSelect?: boolean;
  columns?: any[];
  ids?: string[];
  modalFooterChildren?: React.ReactNode;
  onAssetSelected?: (asset: any) => void;
  onClose?: () => void;
  openInNewTab?: boolean;
  parentIds?: string[];
  renderInModal?: boolean;
  renderStyle?: string;
  resultsPerPage?: number;
  showBackButton?: boolean;
  showDerivedFromFilter?: boolean;
  showIdsFilter?: boolean;
  title?: string;
  version?: string;
  withWrapper?: boolean;
}

export const AssetSelector: React.FC<AssetSelectorProps> = ({
  additionalTopbarComponents = [],
  baseFilters = {},
  closeOnSelect = true,
  columns,
  ids = [],
  showDerivedFromFilter = false,
  showIdsFilter = false,
  modalFooterChildren,
  onClose = () => {},
  onAssetSelected = () => {},
  openInNewTab = true,
  parentIds = [],
  renderInModal = true,
  renderStyle = RENDER_STYLE_CARD,
  resultsPerPage = 6,
  showBackButton = true,
  title = I18n.t('common.asset_selector.header_title'),
  version = 'published',
  withWrapper = false,
}) => {
  const renderModalFooter = () => {
    if (modalFooterChildren) {
      return <ModalFooter>{modalFooterChildren}</ModalFooter>;
    }
  };

  const assetBrowserProps = {
    additionalTopbarComponents,
    assetSelector: true,
    closeOnSelect,
    columns,
    enableAssetInventoryActions: false,
    ids,
    showDerivedFromFilter,
    showIdsFilter,
    initialTab: ASSET_SELECTOR,
    onAssetSelected,
    onClose,
    openInNewTab: openInNewTab,
    pageSize: resultsPerPage,
    parentIds,
    renderStyle,
    selectMode: true,
    showAssetCounts: false,
    showBackButton,
    showFilters: false,
    showHeader: false,
    tabs: {
      [ASSET_SELECTOR]: {
        props: {
          baseFilters: {
            version,
            ...baseFilters,
          },
        },
      },
    },
  };

  if (renderInModal) {
    const modalProps = {
      className: 'asset-selector',
      fullScreen: true,
      onDismiss: onClose,
      overlay: true,
    };

    // EN-41254: this is a hack to fix scrolling issues
    // on the map layer asset selector on small screens
    if (withWrapper) {
      return (
        <Modal {...modalProps}>
          <div className="modal-container-internal-wrapper">
            <ModalHeader title={title} onDismiss={onClose} />
            <ModalContent>
              <AssetBrowser {...assetBrowserProps} />
            </ModalContent>
            {renderModalFooter()}
          </div>
        </Modal>
      );
    }

    return (
      <Modal {...modalProps}>
        <ModalHeader title={title} onDismiss={onClose} />
        <ModalContent>
          <AssetBrowser {...assetBrowserProps} />
        </ModalContent>
        {renderModalFooter()}
      </Modal>
    );
  } else {
    return (
      <div className="asset-selector">
        <AssetBrowser {...assetBrowserProps} />
      </div>
    );
  }
};

export default AssetSelector;
